import type { AutomationUpdateInput } from '@beacon/core/validation';

import type { BeaconClient } from '../client.js';

export interface AutomationRule {
  id: string;
  name: string;
  type:
    | 'contract_expiry'
    | 'report_ready'
    | 'bau_burn_rate'
    | 'sla_overage'
    | 'stale_engagement';
  isEnabled: boolean;
  config: Record<string, unknown>;
}

export interface AutomationListResponse {
  automations: AutomationRule[];
}

export const automationsApi = {
  list(client: BeaconClient): Promise<AutomationListResponse> {
    return client.get<AutomationListResponse>('/api/automations');
  },

  update(
    client: BeaconClient,
    id: string,
    input: AutomationUpdateInput
  ): Promise<AutomationRule> {
    return client.patch<AutomationRule>(
      `/api/automations/${encodeURIComponent(id)}`,
      input
    );
  },
};
